module.exports = __webpack_public_path__ + "static/media/SouthWesternTimes-devicecomp-min.75050781.png";